import { ReactElement } from 'react';
import RichText from './Richtext';
import { IFragmentBelowHeaderBannerFields } from 'types/contentful';

export default function PromotionalBanner({
  bannerText,
  disclaimer,
  colorScheme,
  openInNewTab,
}: IFragmentBelowHeaderBannerFields): ReactElement {
  return (
    <a href="/special-offers">
      <div
        className={`bg-${colorScheme.toLowerCase()} text-white px-2 py-2.5 md:py-4 flex flex-col md:flex-row gap-2 items-center justify-center ${openInNewTab}`}
      >
        {bannerText && (
          <RichText
            document={bannerText}
            classNames="text-center text-large bold-highlight leading-tight"
          />
        )}
        <p className="text-center text-xs ">{disclaimer}</p>
      </div>
    </a>
  );
}
